import React, { useRef } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FilterIcon from '@mui/icons-material/FilterListRounded';
import IconButton from '@mui/material/IconButton';
import VerticalDotsIcon from '@mui/icons-material/MoreVert';

import { useConversationsPageContext } from 'src/pages/landlord/conversations/context';
import FilterModal from 'src/pages/landlord/conversations/components/header/ConversationsFilterModal';
import Responsive from 'src/components/responsive';

export default function ConversationsFilterButton() {
    const { setFilterOpen } = useConversationsPageContext();

    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClick = () => {
        setFilterOpen(true);
    };

    return (
        <>
            <Responsive mobile>
                <IconButton
                    ref={buttonRef}
                    onClick={handleClick} edge="end"
                >
                    <VerticalDotsIcon />
                </IconButton>
            </Responsive>
            <Responsive desktop>
                <Button
                    ref={buttonRef}
                    color="dark"
                    startIcon={<FilterIcon />}
                    onClick={handleClick}
                    data-testid="filter-button"
                >
                    <Typography mt={0.25} variant="body2">Filter</Typography>
                </Button>
            </Responsive>


            <FilterModal anchorEl={buttonRef.current} />
        </>
    );
}
